import { render, staticRenderFns } from "./sizeChartTemp.vue?vue&type=template&id=0062adaf&scoped=true"
import script from "./sizeChartTemp.vue?vue&type=script&lang=js"
export * from "./sizeChartTemp.vue?vue&type=script&lang=js"
import style0 from "./sizeChartTemp.vue?vue&type=style&index=0&id=0062adaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0062adaf",
  null
  
)

export default component.exports